import React from "react";
//#region types
import { AuthHelper } from "utils/helpers";
//#endregion
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region components
import Layout from "components/layout/layout";
import { LoginContainer } from "components/login";
//#endregion

const RootRoute: React.FC = () => {
  const { isAuthenticated } = useSelector((store: AppState) => ({
    isAuthenticated: store.auth.isAuthorized,
  }));

  return AuthHelper.authenticate() || isAuthenticated ? <Layout /> : <LoginContainer />;
};

export default RootRoute;
